export default __webpack_public_path__ + "static/media/N_Nariz.61372c79.svg";